module.exports = __webpack_public_path__ + "f493f98f54c56422da9a3ba9d21906c2.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/orange.png
// module id = 2160
// module chunks = 0